import { useState } from 'react';

export const BlockRencontre = (props) => {
    const enable = props.enable;
    const bkg = props.bkg;
    const href = 'https://www.disneylandparis.com/fr-fr/faq/parcs-a-theme/file-attente-virtuelle';
    const [show, setShow] = useState('hide');
    switch (enable) {
        case 'rendez-vous':
            return (
                <>
                    <div className={`icon-rencontre ${bkg}`} title="Rendez-vous" onClick={() => { show === 'hide' ? setShow('show') : setShow('hide'); }}>
                        <i className="fa fa-info" aria-hidden="true"></i>
                    </div>
                    <div className={`bolo ${bkg} ${show}`} onClick={() => { show === 'show' ? setShow('hide') : setShow('show'); }}>
                        <div className="icon"><i className="fa fa-info" aria-hidden="true"></i></div>
                        <div className="title">Rendez-vous</div>
                        <div className="text">
                            Certains personnages nécessitent de rejoindre une file d'attente virtuelle 
                            sur l'application mobile «Disneyland Paris»
                            ou auprès du «Cast Member» à l’entrée de l'attraction.
                        </div>
                        <a className="link" href={href}>Infos Disney</a>
                    </div>
                </>
            )
        default:
            return (
                <></>
            )
    }
}